import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../commonComponents/modal/Modal';
import translate from '../../../commonComponents/translate';
import WeelodgeMetadata from '../proptype/weelodgeMetadata';
import WeelodgeInfo from './WeelodgeInfo';
import WeelodgeSidebar from './WeelodgeSidebar';

function WeelodgeModal({ onClose, commission }) {
  return (
    <Modal id="weelodgeModal" onClose={onClose}>
      <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-body">
            <div className="row">
              {commission?.metadata && (
                <div className="col-8 info-section">
                  <WeelodgeInfo info={commission.metadata} />
                </div>
              )}
              {commission?.metadata && (
                <div className="col-4 sidebar-section">
                  <WeelodgeSidebar info={commission.metadata} onClose={onClose} />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

WeelodgeModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  commission: PropTypes.shape(WeelodgeMetadata.propType).isRequired,
};

WeelodgeModal.defaultProps = {
};

export default translate(WeelodgeModal);
